function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import { productLstApi, productDeleteApi, offShellApi, productHeadersApi, productExcelApi, updateProductApi, productBatchVirtualSalesApi } from '@/api/product';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
import merchantName from '@/components/merchantName';
import infoFrom from '@/components/productInfo';
import previewBox from './previewBox';
import { mapGetters } from 'vuex';
import Debounce from '@/libs/debounce';
import { ProductTypeEnum as _ProductTypeEnum } from '@/enums/productEnums';
import BatchAudit from '@/views/product/batchAudit.vue';
import { handleDeleteTable } from '@/libs/public';
import { useProduct } from '@/hooks/use-product';
import product from '@/mixins/product';
var headerName = [{
  name: '出售中商品',
  type: 1
}, {
  name: '仓库中商品',
  type: 2
}, {
  name: '待审核商品',
  type: 6
}, {
  name: '审核未通过商品',
  type: 7
}];
var _useProduct = useProduct(),
  productTypeList = _useProduct.productTypeList;
export default {
  name: 'ProductList',
  components: {
    BatchAudit: BatchAudit,
    infoFrom: infoFrom,
    merchantName: merchantName,
    previewBox: previewBox
  },
  mixins: [product],
  data: function data() {
    return {
      productTypeList: productTypeList,
      //商品类型
      componentKey: 0,
      isAtud: false,
      isShow: false,
      productId: 0,
      categoryProps: {
        value: 'id',
        label: 'name',
        children: 'childList',
        expandTrigger: 'hover',
        checkStrictly: false,
        emitPath: false,
        multiple: false
      },
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      isShowSeach: true,
      categoryIdData: [],
      headeNum: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        categoryId: null,
        keywords: '',
        type: '1',
        isSelf: null,
        merId: null,
        isPaidMember: null,
        productType: null
      },
      keywords: '',
      categoryList: [],
      merCateList: [],
      objectUrl: process.env.VUE_APP_BASE_API,
      dialogVisible: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '商品图', '商品名称', '商品售价', '商户名称', '商户类别', '销量', '库存', '审核状态'],
      columnData: ['ID', '商品图', '商品名称', '商品售价', '商户名称', '商户类别', '销量', '库存', '审核状态'],
      isIndeterminate: true,
      merchantList: [],
      search: {
        limit: 10,
        page: 1,
        keywords: ''
      },
      loading: false,
      totalPage: 0,
      total: 0,
      keyNum: 0,
      multipleSelection: [],
      checkedIds: [],
      previewVisible: false,
      frontDomainUrl: '',
      // iframe地址
      formData: {
        ficti: 0,
        idList: []
      }
      //dialogVisibleInfo: false //详情
    };
  },
  mounted: function mounted() {
    if (checkPermi(['platform:product:tabs:headers'])) this.goodHeade();
    if (!localStorage.getItem('merPlatProductClassify')) this.$store.dispatch('product/getAdminProductClassify');
    if (checkPermi(['platform:product:page:list'])) this.getList(1);
    this.checkedCities = this.$cache.local.has('goods_stroge') ? this.$cache.local.getJSON('goods_stroge') : this.checkedCities;
  },
  computed: _objectSpread(_objectSpread({
    ProductTypeEnum: function ProductTypeEnum() {
      return _ProductTypeEnum;
    }
  }, mapGetters(['merPlatProductClassify', 'frontDomain'])), {}, {
    heightBoxs: function heightBoxs() {
      var _this2 = this;
      this.$nextTick(function () {
        // 页面渲染完成后的回调
        return Number(_this2.$refs.headerBox.offsetHeight) - Number(document.documentElement.clientHeight);
      });
    }
  }),
  methods: {
    checkPermi: checkPermi,
    //搜索
    handleSeachList: function handleSeachList() {
      this.getList(1);
      this.goodHeade();
    },
    //批量审核
    handlebatchAudit: function handlebatchAudit() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.$refs.refBatchAudit.dialogVisible = true;
    },
    //批量审核提交成功回调
    subBatchAuditSuccess: function subBatchAuditSuccess() {
      this.subSuccess();
    },
    //详情关闭
    onCloseInfo: function onCloseInfo() {
      this.dialogVisibleInfo = false;
    },
    //批量增加初始销量
    handleBatchSales: function handleBatchSales() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.dialogVisible = true;
    },
    /** 提交按钮 */
    submitForm: Debounce(function (formData) {
      var _this3 = this;
      this.$refs[formData].validate(function (valid) {
        if (valid) {
          _this3.formData.idList = _this3.checkedIds;
          productBatchVirtualSalesApi(_this3.formData).then(function (response) {
            _this3.$modal.msgSuccess('操作成功');
            _this3.getList(1);
            _this3.handleClose();
          });
        }
      });
    }),
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.formData.ficti = 0;
    },
    ishttp: function ishttp(url) {
      return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1;
    },
    // 预览
    handlePreview: function handlePreview(id) {
      this.previewVisible = true;
      this.frontDomainUrl = "".concat(this.$selfUtil.getFrontDomainUrl(), "/pages/goods/goods_details/index?id=").concat(id, "&mt=0");
    },
    getMerId: function getMerId(id) {
      this.tableFrom.merId = id;
      this.subSuccess();
    },
    // 批量下架
    handlebatchOff: function handlebatchOff() {
      if (this.multipleSelection.length === 0) return this.$message.warning('请先选择商品');
      this.handleOff(this.checkedIds);
    },
    // 下架
    handleOff: function handleOff(id) {
      var _this4 = this;
      this.$modalSure('强制下架吗').then(function () {
        offShellApi({
          ids: id.toString()
        }).then(function (res) {
          _this4.$message({
            type: 'success',
            message: '提交成功'
          });
          _this4.subSuccess();
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      var data = [];
      this.multipleSelection.map(function (item) {
        data.push(item.id);
      });
      this.checkedIds = data;
    },
    handleEdit: function handleEdit(row) {
      if (!row && this.checkedIds.length === 0) return this.$message.warning('请至少选择一个商品');
      var _this = this;
      this.$modalParserFrom('编辑商品', '平台商品编辑', 1, {
        ficti: row.ficti || '0',
        id: row.id,
        rank: row.rank
      }, function (formValue) {
        _this.submit(formValue, row.id);
      }, this.keyNum += 5);
    },
    submit: function submit(formValue, id) {
      var _this5 = this;
      var data = {
        id: id,
        ficti: formValue.ficti,
        rank: formValue.rank
      };
      updateProductApi(data).then(function (res) {
        _this5.$message.success('操作成功');
        _this5.$msgbox.close();
        _this5.getList(1);
      }).catch(function () {
        _this5.loading = false;
      });
    },
    subSuccess: function subSuccess() {
      this.getList(1);
      this.goodHeade();
      this.dialogVisibleInfo = false;
    },
    handleAudit: function handleAudit(id, c) {
      //this.getProductInfo(id)
      this.productId = id;
      this.isShow = true;
      this.isAtud = c;
      this.componentKey += 1;
      this.dialogVisibleInfo = true;
      // this.$refs.infoFrom.dialogVisible = true;

      // this.$refs.infoFrom.getProductInfo(id);
    },
    // 导出
    exports: function exports() {
      productExcelApi({
        cateId: this.tableFrom.cateId,
        keywords: this.tableFrom.keywords,
        type: this.tableFrom.type
      }).then(function (res) {
        window.location.href = res.fileName;
      });
    },
    // 获取商品表单头数量
    goodHeade: function goodHeade() {
      var _this6 = this;
      var data = Object.assign({}, this.tableFrom);
      delete data.page;
      delete data.limit;
      delete data.type;
      productHeadersApi(data).then(function (res) {
        res.map(function (item, index) {
          if (item.type === headerName[index].type) item.name = headerName[index].name;
        });
        _this6.headeNum = res;
      }).catch(function (res) {
        _this6.$message.error(res.message);
      });
    },
    // 列表
    getList: function getList(num) {
      var _this7 = this;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      this.listLoading = true;
      productLstApi(this.tableFrom).then(function (res) {
        _this7.tableData.data = res.list;
        _this7.tableData.total = res.total;
        _this7.listLoading = false;
      }).catch(function (res) {
        _this7.listLoading = false;
        _this7.$message.error(res.message);
      });
    },
    reset: function reset() {
      this.keywords = '';
      this.tableFrom.categoryId = null;
      this.tableFrom.keywords = null;
      this.tableFrom.isSelf = null;
      this.tableFrom.merId = null;
      this.tableFrom.isPaidMember = null;
      this.tableFrom.productType = null;
      this.getList(1);
      this.goodHeade();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    // 删除
    handleDelete: function handleDelete(id, type) {
      var _this8 = this;
      this.$modalSure("\u5220\u9664 id \u4E3A ".concat(id, " \u7684\u5546\u54C1")).then(function () {
        var deleteFlag = type == 5 ? 'delete' : 'recycle';
        productDeleteApi(id, deleteFlag).then(function () {
          _this8.$message.success('删除成功');
          handleDeleteTable(_this8.tableData.data.length, _this8.tableFrom);
          _this8.getList();
          _this8.goodHeade();
        });
      });
    },
    renderHeader: function renderHeader(h) {
      var _this9 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this9.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.$set(this, 'card_select_show', false);
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('goods_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    }
  }
};